import {
  Req_GetTemplateList,
  Req_GetTempTypes,
  Req_GetSubjectTree
} from '@/request/subject'
function traversalSubjectTree(state,tree) {
  tree.forEach(item => {
    state.configMap[item.beanId] = item
    item.children && traversalSubjectTree(state,item.children)
  })
}

export default {
  state: {
    templateList:[],
    activeTemplate:null,
    tempTypes: [],
    configList: [],
    configMap:{}
  },
  mutations: {
    initTemplateList(state,payload) {
      state.templateList = payload
    },
    refreshActiveTemplate(state,payload) {
      state.activeTemplate = payload
    },
    initTempTypes(state,payload) {
      state.tempTypes = payload
    },
    initConfigList(state,payload) {
      state.configList = payload
      traversalSubjectTree(state,payload)
    }
  },
  actions: {
    getTemplateList(store) {
      return Req_GetTemplateList().then(res => {
        store.commit('initTemplateList',res)
      }).catch(err => this.$catchErr(err))
    },
    getTempType(store) {
      Req_GetTempTypes().then(res => {
        store.commit('initTempTypes',res)
      }).catch(err => this.$catchErr(err))
    },
    getConfigList(store,payload) {
      Req_GetSubjectTree(payload).then(res => {
        store.commit('initConfigList',res)
      }).catch(err => this.$catchErr(err))
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/subject.js